import {Observable} from 'rxjs/Observable';
import FileStackClient from 'utils/filestack';
import {makePickOptions, multiFilePromiseHandler} from "./utils";

export const fromSources = ['local_file_system', 'imagesearch', 'url'];

export function doPickFile(observer, additionalOptions = {}) {
    let options = makePickOptions(Object.assign({
        fromSources: fromSources,
        accept: ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/svg+xml"],
        maxFiles: 1 // Default is 1, and there is no documentation for 'no max'
    }, additionalOptions));

    multiFilePromiseHandler(observer, FileStackClient.pick(options))
}

export function pickFile(additionalOptions = {}) {
    return (source) => Observable.create((observer) => {
        source.subscribe(
            (val) => doPickFile(observer, additionalOptions),
            (err) => observer.error(err),
            () => observer.complete()
        );
    });
}



// WEBPACK FOOTER //
// ./public/observables/lettables/pickFile.js